import { formatAsShortDate } from "../../../core/helpers/date-formatting-util.js";
import { widget } from "@foretagsplatsen/widgetjs";
import companyChartAssetsLegendItemWidget from "./companyChartAssetsLegendItemWidget.js";
import companyChartLiabilitiesLegendItemWidget from "./companyChartLiabilitiesLegendItemWidget.js";
import companyChartOwnersPartLegendItemWidget from "./companyChartOwnersPartLegendItemWidget.js";

/**
 * Legend for a company chart containing the three different items for the chart: assets, liabilities
 * and owners part
 *
 * @param {highchartWidget} spec.chart - The corresponding highcharts graph. (Used by the legend items).
 * @param {boolean} spec.legendWithDiff - Will modify the CSS so the legend items get the correct height so it also can display a diff row. (Used by the legend items).
 * @param {boolean} spec.disabled - Indicates if the legend is disabled or not. A disabled legend is just, in this case, looking a bit different (desaturated colors). (Used by the legend items).
 * @param {string} [spec.dataHelpName] - String used by the help system to find the chart.
 */
function companyChartLegendWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.legendWithDiff = spec.legendWithDiff;
	my.disabled = spec.disabled;
	my.dateString = undefined;
	my.dataHelpName = spec.dataHelpName || "";

	my.assetsLegendItem = companyChartAssetsLegendItemWidget({
		legendWithDiff: my.legendWithDiff,
		disabled: my.disabled,
	});

	my.ownersPartLegendItem = companyChartOwnersPartLegendItemWidget({
		legendWithDiff: my.legendWithDiff,
		disabled: my.disabled,
	});

	my.liabilitiesLegendItem = companyChartLiabilitiesLegendItemWidget({
		legendWithDiff: my.legendWithDiff,
		disabled: my.disabled,
	});

	that.setCompanyBalance = function (companyBalance) {
		my.dateString = formatAsShortDate(companyBalance.date);

		my.assetsLegendItem.setValue(companyBalance.totalAssets);
		my.assetsLegendItem.setPopoverValues(companyBalance);
		my.ownersPartLegendItem.setValue(-companyBalance.ownersPart);
		my.ownersPartLegendItem.setPopoverValues(companyBalance);
		my.liabilitiesLegendItem.setValue(-companyBalance.totalLiability);
		my.liabilitiesLegendItem.setPopoverValues(companyBalance);

		that.update();
	};

	that.setCompanyBalanceChange = function (companyTransitionBalance) {
		my.assetsLegendItem.setDiff(companyTransitionBalance.totalAssetsChange);

		my.ownersPartLegendItem.setDiff(
			-companyTransitionBalance.ownersPartChange,
		);

		my.liabilitiesLegendItem.setDiff(
			-companyTransitionBalance.totalLiabilityChange,
		);
	};

	that.renderContentOn = function (html) {
		html.div(
			{
				id: "company-chart-legend",
				class: "clearfix",
				"data-help": my.dataHelpName,
			},
			html.div(
				{ class: "col-lg-12 col-md-12 col-sm-12 col-xs-12 nopadding" },
				html.div({ class: "legend-header" }, my.dateString || ""),
				html.ul(
					{ class: "legend" },
					my.assetsLegendItem,
					my.ownersPartLegendItem,
					my.liabilitiesLegendItem,
				),
			),
		);
	};

	return that;
}

export default companyChartLegendWidget;
